export default __webpack_public_path__ + "static/media/handicap-cognitif.89771eca.svg";